import { fetchWebApi } from '@/services/messaging/fetchWebApi';

export function getMyDepartmentTexts() {
  return fetchWebApi("Colleagues/GetMyDepartmentTexts");
}
